(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookStatistic', HandbookStatistic);

    HandbookStatistic.$inject = ['$resource'];

    function HandbookStatistic ($resource) {
        var resourceUrl =  'api/handbook-statistics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
